
//配置项
let componentName = 'authPerson';

const columns =(self, handleDelete, handleChangeStutas) => {
  return [ {
      name: "personId",
      key: "personId",
      formItem: {
        type: "hidden",
      }
    },
    {
      title: "账户",
      name: "userName",
      dataIndex: "userName",
      tableItem: {
      },
    },
    {
      title: "姓名",
      name: "fullName",
      dataIndex: "fullName",
      tableItem: {
      },
    },
    {
      name: "身份证号/工号",
      key: "idCard",
      formItem: {
      }
    },
    {
      title: "账号状态",
      name: "state",
      dataIndex: "state",
      tableItem: {
      },
      searchItem: {},
      dict: [
        { code: "ENABLE", codeName: "激活" },
        { code: "PROHIBIT", codeName: "禁用" }
      ]
    },
    {
      title: "姓名",
      name: "fullName",
      dataIndex: "fullName",
      searchItem: {
      },
    },
    {
      title: "手机号",
      name: "mobile",
      dataIndex: "mobile",
      tableItem: {
      },
    },

    {
      title: "操作",
      name: "action",
      dataIndex: "action",
      tableItem: {
         render: (text, record) => {
        return (
          <span>
          </span>
        )
      }
      },
    },
    // {
    //   title: "操作",
    //   dataIndex: "action",
    //   key: "action",
    //   render: (text, record) => {
    //     return (
    //       <span>
    //       </span>
    //     )
    //   }
    // }
  ]
}

const templateConfig = {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns:columns,
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort:[],
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: null,
          isScroll: true,
          loading: false
        },
        //commonOperate: {}
        rowOperateSort: ['look','roleUserManager'],
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: {children: "查看任职"},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "look",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return <div></div>
              }
            }
          },
          {
            key: "roleUserManager",
                custom: true,
                params: { children: "人员维护"},
                customOnClick: {
                  key: "jumpPage",
                  params: {
                    key: "push",
                    pathname:"/auth/roleList/roleUserList"
                  },
                }
        },
      ]
      }
    }
};




let reduxTemplateCofig = (args) => {
    let apis = {
        list: {
          path: `${componentName}/listByPage`,
          payload: {
            key: `${componentName}@listByPage`,

        apiParams: {
            procInstId: args['procInstId'],
            state:1
          }
          }
        }
      }
  return {
    apis,
    componentName,
    keepInitApiParams: true,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig }
